import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const TESTIMONIALS = [
  {
    initials: "MR",
    color: "#4285F4",
    name: "Marco R.",
    business: "Pizzeria · Napoli",
    quote:
      "Da quando l'espositore è sul bancone, le recensioni arrivano da sole. In due mesi siamo passati da 40 a oltre 120 recensioni e su Maps ci trovano subito.",
    stars: 5,
  },
  {
    initials: "GT",
    color: "#EA4335",
    name: "Giulia T.",
    business: "Salone di bellezza · Milano",
    quote:
      "Le clienti fanno tap mentre aspettano il caffè. Zero imbarazzo nel chiedere la recensione: la carta lo fa per me, e la mia scheda Google è rinata.",
    stars: 5,
  },
  {
    initials: "AB",
    color: "#34A853",
    name: "Alessandro B.",
    business: "Officina meccanica · Torino",
    quote:
      "Pensavo fosse complicato, invece è arrivata già pronta: scartata e funzionante. I clienti nuovi mi dicono 'ti ho scelto per le recensioni'.",
    stars: 5,
  },
];

export const Testimonials = () => (
  <section id="testimonianze" data-testid="testimonials-section" className="bg-[#F8FAFC] py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mx-auto max-w-2xl text-center">
        <span className="rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4285F4]">
          Chi lo usa già
        </span>
        <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Le attività che hanno acceso le loro 5 stelle.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          Ristoranti, saloni e officine in tutta Italia raccolgono recensioni ogni giorno con TapGoogle.com.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-8 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.12 * i} className="h-full">
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-blue-500/10"
            >
              <Quote className="h-7 w-7 fill-blue-50 text-[#4285F4]" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700 sm:text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                <span
                  className="flex h-11 w-11 items-center justify-center rounded-full text-sm font-bold text-white"
                  style={{ backgroundColor: t.color }}
                >
                  {t.initials}
                </span>
                <div className="flex-1">
                  <p className="font-display text-sm font-bold text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.business}</p>
                </div>
                <span className="flex gap-0.5">
                  {[...Array(t.stars)].map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-[#FBBC04] text-[#FBBC04]" />
                  ))}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
